// extracted by mini-css-extract-plugin
export default {"row":"styles_row__GdCmA","text":"styles_text__i9qPW","col":"styles_col__A+dNQ","skill-box":"styles_skill-box__vaf4W","skill-text":"styles_skill-text__tR4VH"};